import { render, staticRenderFns } from "./OrganizerBatchEdit.vue?vue&type=template&id=1f1faee7&"
import script from "./OrganizerBatchEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizerBatchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports